import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';

import localUtil from '../../lib/util';
import Sparkline from '../../components/gui/sparkline';

function displayMaxLetter(str, max) {
    if (!str || str.length < max) {
        return str;
    }
    return str.substring(0, max) + '...';
}
@observer
class Convention extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            sections: fields.get('contact'),
            openConventions: [],
        };
        this.mainContainer = null;
    }

    newConvention = e => {
        const { id, title } = e.target.closest('button').dataset;
        const { drawerLevel = 1 } = this.props;
		const { appState, timetrackersStore } = this.props.stores;
		const { drawerHeightLarge } = appState;
		appState.openDrawer('conventionWizard', {
			height: drawerHeightLarge,
            callback: () => {
                appState.toggleDrawer();
                this.loadAll(this.props, false);
            },
		}, drawerLevel + 2);
	}

    viewConvention = (e, props) => {
        const { view } = this.props;
        if (view) {
            return view(e);
        }
        const { id, title } = props ? props : e.target.closest('.box-line').dataset;
        return route(`/convention/${id}`);

        // const { appState } = this.props.stores;
        // const { drawerLevel = 1 } = this.props;
        // const { drawerHeightLarge } = appState;
        // appState.openDrawer('viewConvention', {
        //     id,
        //     height: drawerHeightLarge,
        //     // editFunction: this.editTimeConvention,
        //     callback: () => {
        //         appState.toggleDrawer();
        //         this.loadAll(this.props, false);
        //     },
        // }, drawerLevel + 1);
    }

    viewTags = obj => {
        const { userStore } = this.props.stores;
        const { user = {}, isAdmin } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const tagClass = darkmode ? 'dark' : 'light';

        const hasStats = (isAdmin || obj.user === user.id) && (obj.totalViews > 0 || obj.weeklyStats?.length > 0);
        const hasTags = obj.tags?.length > 0;
        const hasFiles = obj.files?.length > 0;

        if (!hasStats && !hasTags && !hasFiles && !obj.loans?.length && !obj.ownedByOther && !obj.url && !obj.parents?.length) {
            return '';
        }

        return (<>
            <div class='w-100 overflow-hidden'>
                <div class='box-line-tags d-flex flex-nowrap'>
                    {hasStats && <>
                        <span class={`badge text-bg-light me-1 mt-1`} title='Views'>
                            <i class='fa-solid fa-eye' /> {obj.totalViews}
                            {obj.viewsTrend !== 0 && (
                                <span class={`ms-1 ${obj.viewsTrend > 0 ? 'text-success' : 'text-danger'}`}>
                                    {obj.viewsTrend > 0 ? '+' : ''}{obj.viewsTrend}%
                                </span>
                            )}
                        </span>
                        {obj.weeklyStats?.length > 1 && (
                            <span class={`badge text-bg-light me-1 mt-1 py-1`} title='Weekly trend'>
                                <Sparkline data={obj.weeklyStats} valueField='views' height={16} barWidth={3} />
                            </span>
                        )}
                        {obj.totalSignups > 0 && (
                            <span class={`badge text-bg-light me-1 mt-1`} title='Signups'>
                                <i class='fa-solid fa-user-plus' /> {obj.totalSignups}
                            </span>
                        )}
                        {obj.totalResultsEntered > 0 && (
                            <span class={`badge text-bg-light me-1 mt-1`} title='Results entered'>
                                <i class='fa-solid fa-trophy' /> {obj.totalResultsEntered}
                            </span>
                        )}
                    </>}
                    {hasFiles && <>
                        <span class={`badge text-bg-light me-1 mt-1`}>
                            <i class='fa-duotone fa-file' /> <span class='font-weight-lighter'> x {obj.files.length}</span>
                        </span>
                    </>}
                    {hasTags && obj.tags.map(tag => {
                        return (<>
                            <span
                                class={`badge text-bg-${tagClass} me-1 mt-1`}
                                onClick={this.toggleTagFilter}
                                data-tag={tag.name}
                            >#{tag.name}</span>
                        </>);
                    })}
                </div>
            </div>
        </>);
    }

    loadAll = async (props = this.props, emptyFirst = false) => {
        const { id, todayOnly, openRegistrations } = props;
        const { conventionStore } = this.props.stores;
        // if (emptyFirst) {
        //     conventionStore.updateKeyValue('conventions', {});
        // }
        conventionStore.setRefreshPage(() => {
            this.loadAll();
        });
        const response = await conventionStore.load(id, false, {
            query: {
                hostname: conventionStore.currentHostname,
                todayOnly,
                openRegistrations,
            },
            addData: ['tags', 'members'],
            skipUpdate: true,
            sort: 'startDate',
        });
        this.setState({ openConventions: response });
    }

    toggleShowAll = () => {
        this.setState({ showAll: !this.state.showAll });
    }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    render() {
        const { showAll, openConventions } = this.state;
        const {
            classNames = '',
            title = 'Stevner / treninger',
            children,
            todayOnly,
            openRegistrations,
            hideEmpty,
        } = this.props;

        const { appState, userStore, conventionStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const finalList = openConventions || [];

        // hideEmpty hides the entire box — including the admin add/filter buttons —
        // unlike GuiList's hideEmpty below, which admins bypass.
        if (hideEmpty && finalList.length === 0) {
            return (<></>);
        }

        return (<>

            <div class={`d-flex justify-content-start flex-row w-100 position-relative`}>
                <div class='flex-fill'>
                    {/* <h5 class='ms-3 mb-3'>{convention.title}</h5> */}
                </div>
                {isCustomerAdmin && <div class={`position-absolute`} style={`top: 15px; right: 5px; z-index: 1000;`}>
                    <button onClick={this.newConvention} class={`btn btn-sm btn-outline-success rounded-pill me-2`}>
                        <i class={`fa-regular fa-plus`} />
                    </button>
                    <button onClick={this.toggleShowAll} class={`btn btn-sm btn${showAll ? '' : '-outline'}-success rounded-pill me-2`}>
                        <i class={`fa-regular fa-filter`} />
                    </button>
                </div>}
                {/* <div class='' style='margin-right: 65px;'>
                    <span onClick={this.editConvention} class={`text-primary ${linkTextClass}`} style={`${linkTextStyle}`}>
                        <i class={`fa-regular fa-pen ms-3 me-1`} />
                    </span>
                </div> */}
            </div>

            <GuiList
                stores={this.props.stores}
                holdingStore={conventionStore}
                classNames={classNames}
                styles={isAdmin ? 'border: 0.5px #a0a0a0 dotted;' : ''}
                category='conventions'
                classNamesList={'mx-0 mb-3'}
                view={this.viewConvention}
                title={title}
                // title={todayOnly ? title : title}
                // filter={this.filter}
                list={finalList}
                elTitle={e => {
                    if (!e.title) return 'No title';
                    const start = e.startDate ? new Date(e.startDate).getTime() : 0;
                    const end = e.endDate ? new Date(e.endDate).getTime() : 0;
                    const now = Date.now();
                    const isOngoing = start && end && start <= now && now <= end;
                    const hasStages = (e.stages?.length || 0) > 0;
                    return (<>
                        <span class='font-weight-lighter'>
                            {util.formatDate(e.startDate, {
                                hour12: false,
                                hour: '2-digit',
                                minute: '2-digit',
                                day: '2-digit',
                                month: 'short',
                                year: '2-digit',
                                locale: 'nb-NO',
                            }, true)}
                        </span>
                        <span class='ms-2'>
                            {e.title}
                        </span>
                        {e.type === 'dugnad' && (
                            <span class='badge text-bg-light ms-2' style='font-size: 0.7rem;'>
                                <i class='fa-duotone fa-people-carry-box me-1' />
                                <Text id='convention.dugnad-badge'>Dugnad</Text>
                            </span>
                        )}
                        {isOngoing && hasStages && (
                            <a
                                href={`/convention/${e.id}/results`}
                                class='badge bg-danger rounded-pill ms-2 text-decoration-none'
                                onClick={(ev) => ev.stopPropagation()}
                                title='Live resultatliste'
                            >
                                <i class='fa-regular fa-circle-dot me-1' />
                                <Text id='convention.live-results-pill'>Live</Text>
                            </a>
                        )}
                    </>);
                }}
                elInfo1={e => <>
                    <small class='text-muted'>
                        {displayMaxLetter(e.ingress, 100)}
                    </small>
                </>}
                // elInfo1={e => <>
                //     {e.stages?.map(stage => {
                //         return (<>
                //             <span class='badge text-bg-light me-1 mt-1'>
                //                 <i class='fa-duotone fa-flag' /> {stage.name} <span class='font-weight-lighter'>({stage.type})</span>
                //             </span>
                //         </>);

                //     })}
                // </>}
                // elInfo2={e => e.isCompetition ? <>
                //     <span class={`badge text-bg-danger me-1 mt-1`}>
                //         <Text id='convention.competition'>Competition</Text>
                //     </span>
                // </> : ''}
                // elInfo3={e => e.startDate ? <>
                //     <span class='text-secondary me-3'>
                //         {util.formatDate(e.startDate, {
                //             hour12: false,
                //             hour: '2-digit',
                //             minute: '2-digit',
                //             day: '2-digit',
                //             month: 'short',
                //             year: '2-digit',
                //             locale: 'nb-NO',
                //         }, true)}
                //     </span>
                // </> : ''}
                elIcon={e => {
                    let textColor = 'text-secondary';
                    let animateIcon = '';
                    let icon = 'fa-lock';
                    const now = new Date();
                    // Check if the convention is in the future
                    const endOfDay = new Date();
                    endOfDay.setHours(23, 59, 59, 999);
                    if (e.startDate && new Date(e.startDate) > endOfDay) {
                        textColor = 'text-primary';
                    }
                    // Check if date is today
                    if (e.startDate && new Date(e.startDate).toDateString() === new Date().toDateString()) {
                        textColor = 'text-success';
                        animateIcon = 'fa-bounce';
                    }
                    if (e.public) {
                        icon = 'fa-globe';
                        // Check if it is in the past
                        if (e.endDate && new Date(e.endDate) < now) {
                            // textColor = 'text-success';
                            icon = 'fa-check';
                        }
                    } else {
                        textColor = 'text-danger';
                    }


                    return `fa-duotone ${icon} ${textColor} ${animateIcon}`;
                }}
                iconStyle={'font-size: 1.2em; min-width: 25px; width: 25px;'}
                viewTags={this.viewTags}
                hideEmpty={isAdmin ? false : true}
                editElement={this.editConvention}
                help={children}
                showEmptyImage={true}
                imgHeight={'55px'}
                // wrapperStyles={'min-height: 20px;'}
            />
        </>);
    }
}

export default Convention;
